export enum WrappedChapter {
	INTRO = 'intro_page',
	DAYGOALS_ACHIEVED = 'daygoals_achieved_page',
	MINUTES_PRACTICED = 'minutes_practiced_page',
	MATH_QUESTIONS = 'math_questions_page',
	LANGUAGE_QUESTIONS = 'language_questions_page',
	TOPIC_GROWTH_START = 'topic_growth_start_page',
	TOPIC_GROWTH_RESULT = 'topic_growth_result_page',
	MOST_PRACTICED_TOPICS = 'most_practiced_topics_page',
	MOST_CORRECT_TOPICS = 'topics_most_correct_page',
	PLAYER_TYPE = 'player_type',
	PARTY_GAME = 'party_game_page',
}

export interface PageRow {
	name: string;
	value: string | number;
}

export type PlayerType = 'day_goal_champion' | 'traveller' | 'math_surfer' | 'letter_pilot';

export interface PageData {
	title: string | null;
	subtitle: string | null;
	texts: string[];
	start_texts?: string[];
	rows?: PageRow[];
	free_play_topic_category_title?: string;
	free_play_topic_category_id?: number | null;
	user_learning_path_section_id?: number | null;
	type?: PlayerType;
}

export interface YearSummaryData {
	intro_page: PageData;
	daygoals_achieved_page: PageData;
	minutes_practiced_page: PageData;
	math_questions_page: PageData;
	language_questions_page: PageData;
	topic_growth_start_page: PageData;
	topic_growth_result_page: PageData;
	most_practiced_topics_page: PageData;
	topics_most_correct_page: PageData;
	player_type: PageData;
	party_game_page: PageData;
}

export interface ChapterItem {
	type: WrappedChapter;
	data: PageData;
}
